import { MetadataDataSource, NullMetadataDataSource } from "../datasource/metadata";
import { AttemptId, ProductId } from "../datasource";

export abstract class MetadataModel<P extends ProductId, A extends AttemptId> {
	datasource: MetadataDataSource<P, A>;

	protected constructor(datasource?: MetadataDataSource<P, A>) {
		this.datasource = datasource ?? new NullMetadataDataSource();
	}

	abstract getProductId(): Promise<P>
	abstract getAttempt(): Promise<A>
	abstract getUrl(): Promise<string>
	abstract getScreenshot(): Promise<string>
}

export class NullMetadataModel<P extends ProductId, A extends AttemptId> implements MetadataModel<P, A> {
	datasource: MetadataDataSource<P, A>;

	getProductId(): Promise<P> {
		throw new Error("Method not implemented.");
	}

	getAttempt(): Promise<A> {
		throw new Error("Method not implemented.");
	}

	getUrl(): Promise<string> {
		throw new Error("Method not implemented.");
	}

	getScreenshot(): Promise<string> {
		throw new Error("Method not implemented.");
	}
}

